{
  "confirm_title": "Are you sure you want to leave {{title}}?",
  "confirm_message": "You'll no longer have access to this schedule.",
  "confirm_submit": "Leave schedule",
  "error_toast": "Error leaving schedule"
}
